import Api from "@/api";
import { useLoadedQuery } from "@/api/queryClient";
import * as Pages from "@/components/Pages";

export async function loader() {
  const companyInput = { includeAdmins: true, includeOwners: true, includePermissions: true };

  await Api.companies.getQuery(companyInput);

  return { companyInput };
}

type LoaderResult = Awaited<ReturnType<typeof loader>>;

export function useLoadedData() {
  const { companyInput } = Pages.useLoadedData<LoaderResult>();
  const { data } = useLoadedQuery(Api.companies.getQueryOptions(companyInput));
  const company = data?.company;

  if (!company) throw new Error("Company administration data is unavailable");

  return {
    company,
    adminIds: (company.admins ?? []).map((a) => a.id),
    ownerIds: (company.owners ?? []).map((o) => o.id),
  };
}
